"use client"

import { useEffect } from "react"

import { useLocalizedPush } from "@/lib/hooks/use-navigation"
import { ROUTES, SESSION_EXPIRED_PARAM } from "@/lib/routes"
import { onSessionExpired } from "@/platform/session/session-events"

export const SessionExpiredRedirect = () => {
  const localizedPush = useLocalizedPush()

  useEffect(() => onSessionExpired(() => localizedPush(`/${ROUTES.ACCOUNT}?${SESSION_EXPIRED_PARAM}=1`)), [localizedPush])

  return null
}
